/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AgentPolicyGrantCheck,
  AgentPolicyGrantCheck$inboundSchema,
} from "./agentpolicygrantcheck.js";

export type CheckAgentPolicyGrantsResult = {
  /**
   * One answer per requested grant, in request order.
   */
  results: Array<AgentPolicyGrantCheck>;
};

/** @internal */
export const CheckAgentPolicyGrantsResult$inboundSchema: z.ZodMiniType<
  CheckAgentPolicyGrantsResult,
  unknown
> = z.object({
  results: z.array(AgentPolicyGrantCheck$inboundSchema),
});

export function checkAgentPolicyGrantsResultFromJSON(
  jsonString: string,
): SafeParseResult<CheckAgentPolicyGrantsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CheckAgentPolicyGrantsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CheckAgentPolicyGrantsResult' from JSON`,
  );
}
